export enum WalletProviders {
  // Social
  Google = "google",
  GitHub = "github",
  Discord = "discord",
  Telegram = "telegram",
  Steam = "steam",
  Twitch = "twitch",
  Email = "email",
  Passkey = "passkey",
  X = "x",
  Coinbase = "coinbase",
  Line = "line",
  Apple = "apple",
  Phone = "phone",
  Farcaster = "farcaster",
  Facebook = "facebook",
  Guest = "guest",
  //   WalletProviders
  MetaMask = "io.metamask",
  CoinbaseWallet = "com.coinbase.wallet",
  Rainbow = "me.rainbow",
  Rabby = "io.rabby",
  ZerionWallet = "io.zerion.wallet",
}
